import { SxProps, Theme } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField'
import { dateFormat } from 'app/appSettings'
import { FormErrorLabel } from 'app/views/common/labels/FormErrorLabel'
import { useField } from 'formik'
import moment from 'moment'
import CustomDatePicker from './CustomDatePicker'

export interface CustomDatePickerWithFormikProps
  extends Omit<TextFieldProps, 'value' | 'onChange'> {
  name: string
  label?: string
  helperText?: string | React.ReactNode
  minDate?: Date | string | null
  maxDate?: Date | string | null
  sx?: SxProps<Theme>
}

const CustomDatePickerWithFormik = ({
  name,
  label,
  ...props
}: CustomDatePickerWithFormikProps): JSX.Element => {
  const [field, meta, helpers] = useField(name)
  const value = field.value ?? null
  const showError = Boolean(meta.touched && meta.error)

  return (
    <>
      <CustomDatePicker
        {...props}
        value={value != null
          ? moment.utc(value)
          : null}
        onChange={(newDate) => {
          const parsedValue = newDate ? moment.utc(newDate, dateFormat, true).format(dateFormat) : null
          helpers.setValue(parsedValue)
          if (!meta.touched) {
            helpers.setTouched(true, false)
          }
        }}
      />
      {showError && <FormErrorLabel id={name} error={meta.error} />}
    </>

  )
}

export default CustomDatePickerWithFormik
